<template>
  <div :class="isClosed?'menu1':'menu'">
    <div style="width:100%;height:16px">
      <span :class="isClosed?'span':'span1'" @click="isClosed = !isClosed">|||</span>
    </div>
    <!-- <el-scrollbar>
      
    </el-scrollbar> -->
    <div class="title" v-if="!isClosed">
      <img src="/logo50.png"/>
    </div>
    <el-menu
      @select="activeRoute"
      id="el-menu"
      :collapse-transition="false"
      :collapse="isClosed"
      background-color="#3a3b44"
      text-color="#fff"
      active-text-color="#fff">
      <MenuItem :treeData="treeData" :showtext="isClosed"/>
    </el-menu>
  </div>
</template>
         
<script>
import { PowerService } from '../../service/power.service'
import MenuItem from './menuItem.component';
import baron from 'baron';

  export default {
    name: 'menuComponent',
    components: { MenuItem },
    data() {
      return {
        treeData: [],
        isClosed:false,
        screenWidth: document.body.clientWidth
      }
    },
    async created() {
      const { left_menu } = await PowerService.getMenuList();
      this.treeData = left_menu;
    },
    mounted() {
      baron({root: '#el-menu'}).update()
      const that = this
      window.onresize = () => {
          return (() => {
              window.screenWidth = document.body.clientWidth
              that.screenWidth = window.screenWidth
          })()
      }
    },
    methods: {
      activeRoute(url) {
        this.$router.push(url);
      }
    },
    watch:{
      screenWidth(val){
        this.screenWidth = val
        let that = this
        setTimeout(function(){
          if(that.screenWidth<768){
            that.isClosed = true
          }
        },400)
      }
    }
  }
</script>

<style lang="scss" scoped>
.span{
  float:right;
  font-size: 20px;
  margin-right:10px;
  margin-top:0px;
  color:#fff;
  cursor: pointer;
}
.span1{
  float:right;
  font-size: 20px;
  margin-right:10px;
  margin-top:0px;
  color:#fff;
  transform: rotate(90deg);
  cursor: pointer;
}
.menu {
  width: 200px;
  height: 100%;
  background-color: #3a3b44;
}
.menu1 {
  width: 60px;
  height: 100%;
  background-color: #3a3b44;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
}
#el-menu {
  height: calc(100% - 95px);
  overflow-y: auto;
  overflow-x: unset;
  & /deep/ .el-submenu {
    margin-top: 0px;
  }
  & /deep/ .el-submenu__title {
    width: 172px;
    height: 42px;
    font-size: 16px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 0;
    i {
      font-size: 16px;
    }
    &:hover {
      background: #0a65ca !important;
    }
  }
  & /deep/ .is-opened > .el-submenu__title {
    background: #0a65ca !important;
  }
  & /deep/ .el-menu-item {
    width: 172px;
    margin-top: 19px;
    height: 38.5px;
    min-width: auto;
    border-radius: 14px;
    display: flex;
    font-size: 16px;
    align-items: center;
    justify-content: left;
    i {
      font-size: 16px;
    }
    &:hover {
      color: #0a65ca !important;
    }
  }
  & /deep/ .el-submenu__icon-arrow {
    position: static;
    font-size: 19px;
    color: #fff;
  }
}
.title {
  // margin-top: 15px;
  height: 80px;
  background: #3a3b44;
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 18px;
  justify-content: center;
  img {
    height: 80px;
    margin-right: 15px;
  }
}
</style>